import type { EnforcementType } from './enforcement';

const matchPrivateStage = (s: string): string | null => {
  if (s.includes('letter before claim') || s.includes('letter before action') || s.includes('lbc') || s.includes('lba')) {
    return 'Letter Before Claim';
  }
  if (s.includes('court claim') || s.includes('county court') || s.includes('claim form') || s.includes('claim number')) {
    return 'Court Claim';
  }
  if (s.includes('debt recovery') || s.includes('debt collection')) return 'Debt Recovery';
  if (s.includes('final reminder') || s.includes('final notice') || s.includes('final demand')) return 'Final Reminder';
  if (s.includes('reminder')) return 'Reminder';
  if (s.includes('notice to keeper') || s.includes('ntk')) return 'Notice to Keeper';
  if (s.includes('notice to driver') || s.includes('ntd')) return 'Notice to Driver';
  if (s.includes('parking charge notice') || s.includes('parking charge') || s.includes('pcn')) return 'Parking Charge Notice';
  if (s.includes('order for recovery') || s.includes('charge certificate') || s.includes('notice to owner')) return 'Debt Recovery';
  return null;
};

export const inferPrivateStageFromText = (rawText: string): string | null => {
  const s = String(rawText || '').toLowerCase();
  return matchPrivateStage(s);
};

const normalizePrivateStage = (raw?: string | null) => {
  const s = String(raw ?? '').trim().toLowerCase();
  if (!s) return '';
  const matched = matchPrivateStage(s);
  return matched || String(raw ?? '').trim();
};

const normalizeStatutoryStage = (raw?: string | null) => {
  const s = String(raw ?? '').trim().toLowerCase();
  if (!s) return '';
  if (s.includes('order for recovery') || s === 'ofr') return 'Order for Recovery';
  if (s.includes('charge certificate') || s === 'cc') return 'Charge Certificate';
  if (s.includes('pcn') && (s.includes('nto') || s.includes('notice to owner') || s.includes('n.t.o') || s.includes('pcn/nto'))) return 'Notice to Owner';
  if (s.includes('notice to owner') || s === 'nto' || s.includes('n.t.o')) return 'Notice to Owner';
  if (s.includes('pcn')) return 'PCN Issued';
  return String(raw ?? '').trim();
};

export const normalizeStage = (raw?: string | null, enforcementType: EnforcementType = 'statutory') => {
  return enforcementType === 'private' ? normalizePrivateStage(raw) : normalizeStatutoryStage(raw);
};

export const getStageDisplayLabel = (raw?: string | null, enforcementType: EnforcementType = 'statutory') => {
  const normalized = normalizeStage(raw, enforcementType);
  if (enforcementType === 'private') {
    if (normalized === 'Parking Charge Notice' || normalized === 'Notice to Keeper' || normalized === 'Notice to Driver') {
      return 'PCN / NTK';
    }
    return normalized || String(raw ?? '').trim();
  }
  if (normalized === 'PCN Issued' || normalized === 'Notice to Owner') return 'NtO / Postal PCN';
  return normalized || String(raw ?? '').trim();
};

export const isPcnOrNtoStage = (raw?: string | null) => {
  const normalized = normalizeStage(raw, 'statutory');
  return normalized === 'PCN Issued' || normalized === 'Notice to Owner';
};
